import React, { useState } from "react";
import {
  TextField,
  Button,
  Box,
  Typography,
  Alert,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import api from "../api";

const Login = () => {
  const [nome, setNome] = useState("");
  const [senha, setSenha] = useState("");
  const [erro, setErro] = useState("");
  const [usuarioParaRecuperar, setUsuarioParaRecuperar] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [mensagem, setMensagem] = useState("");

  const handleLogin = async (e) => {
    e.preventDefault();
    setErro("");

    try {
      const response = await api.post("/auth/login", { nome, senha });
      const token = response.data.token;

      // Salvar o token no localStorage
      localStorage.setItem("token", token);

      // Redirecionar para a página inicial
      window.location.href = "/";
    } catch (error) {
      setErro("Credenciais inválidas. Tente novamente.");
    }
  };

  const handlePasswordReset = async () => {
    try {
      setMensagem("");
      await api.post("/auth/reset-password", { nome: usuarioParaRecuperar });
      setMensagem(
        "Um link para redefinir a senha foi enviado ao e-mail associado a este usuário."
      );
      setIsModalOpen(false); // Fechar o modal após o envio
      setUsuarioParaRecuperar("");
    } catch (error) {
      setMensagem(
        error.response?.data?.message ||
          "Erro ao solicitar redefinição de senha."
      );
    }
  };

  return (
    <Box
      sx={{
        maxWidth: { xs: 300, sm: 400 },
        margin: "0 auto",
        padding: { xs: 2, sm: 4 },
        textAlign: "center",
        backgroundColor: "#f9f9f9",
        borderRadius: 2,
        boxShadow: 3,
      }}
    >
      <img
        src="/logocncg.png"
        alt="CNCG Logo"
        style={{
          width: "120px",
          height: "auto",
          marginBottom: "20px",
        }}
      />
      <Typography variant="h4" component="h1" mb={2}>
        Login
      </Typography>
      <form onSubmit={handleLogin}>
        <TextField
          label="Nome"
          value={nome}
          onChange={(e) => setNome(e.target.value)}
          fullWidth
          margin="normal"
          required
        />
        <TextField
          label="Senha"
          type="password"
          value={senha}
          onChange={(e) => setSenha(e.target.value)}
          fullWidth
          margin="normal"
          required
        />
        {erro && (
          <Alert severity="error" sx={{ mt: 2 }}>
            {erro}
          </Alert>
        )}
        <Button
          type="submit"
          variant="contained"
          color="primary"
          fullWidth
          sx={{
            mt: 2,
            fontSize: { xs: "0.8rem", sm: "1rem" },
          }}
        >
          Entrar
        </Button>
      </form>

      {/* Botão de "Esqueci a Senha" */}
      <Button
        onClick={() => setIsModalOpen(true)}
        color="secondary"
        sx={{ mt: 2, fontSize: { xs: "0.7rem", sm: "0.9rem" } }}
      >
        Esqueci minha senha
      </Button>

      {/* Modal para redefinição de senha */}
      <Dialog open={isModalOpen} onClose={() => setIsModalOpen(false)}>
        <DialogTitle>Esqueci minha senha</DialogTitle>
        <DialogContent>
          <TextField
            label="Nome do Usuário"
            value={usuarioParaRecuperar}
            onChange={(e) => setUsuarioParaRecuperar(e.target.value)}
            fullWidth
            margin="normal"
            required
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setIsModalOpen(false)} color="secondary">
            Cancelar
          </Button>
          <Button onClick={handlePasswordReset} color="primary">
            Enviar
          </Button>
        </DialogActions>
      </Dialog>

      {/* Mensagem de sucesso ou erro */}
      {mensagem && (
        <Alert
          severity={mensagem.includes("link") ? "success" : "error"}
          sx={{ mt: 2 }}
        >
          {mensagem}
        </Alert>
      )}
    </Box>
  );
};

export default Login;
